import { Outlet, useResolvedPath } from "react-router";
import { SchoolGrid } from "../../components/DataGrid/SchoolGrid";

export default function School() {
  const path = useResolvedPath();
  return (
    <main
      style={{ height: path.pathname.includes("/school/") && "fit-content" }}>
      <Outlet />
    </main>
  );
}
